<ng-template [ngIf]="template">
			<div class="gruppi_competenza" *ngIf="template.templateProfiloGruppiOperativi && template.templateProfiloGruppiOperativi.length > 0">
				<div class="titleblock template">
					<h4 class="titlelevelcompetenza">Gruppi operativi</h4>
				</div>	
					
				<div class="row">
					<ul class="gruppi">	
						<li>
							 <ng-template ngFor let-permesso [ngForOf]="template.templateProfiloGruppiOperativi">
								   <div class="col-sm-12 bloccodati" *ngIf="permesso.label">
								 	   <p>
										<span class="col-sm-12">{{permesso.label | tipoPraticaPipe}}</span>
									   </p>
 								   </div>
						     </ng-template>
						</li>
					</ul>
				</div>
			</div>												
			
			<div class="gruppi_competenza" *ngIf="template.templateProfiloGruppiOrganizzativi && template.templateProfiloGruppiOrganizzativi.length > 0">
				<div class="titleblock template">
					<h4 class="titlelevelcompetenza">Gruppi organizzativi</h4>
				</div>	
					
				<div class="row">
					<ul class="gruppi">	
						<li>
							 <ng-template ngFor let-permesso [ngForOf]="template.templateProfiloGruppiOrganizzativi">
								   <div class="col-sm-12 bloccodati" *ngIf="permesso.label">
								 	   <p>
										<span class="col-sm-12">{{permesso.label}}</span>
									   </p>
 								   </div>
						     </ng-template>
						</li>
					</ul>
				</div>
					
			</div>
			
			<div class="gruppi_competenza" *ngIf="template.permessiPerGruppoOrganizzativo && template.permessiPerGruppoOrganizzativo.length > 0">
				<div class="titleblock template">
					<h4 class="titlelevelcompetenza">Visibilità e operatività per gruppo organizzativo</h4>
				</div>	
					
				<div class="row">
					<ul class="gruppi">	
						<li *ngFor="let gruppoPermessi of gruppiPermessiOrdinati">
							<!-- Mostro il nome del gruppo -->
							<div class="col-sm-12 bloccodati" *ngIf="gruppoPermessi.idGruppo">
								<p>
									<span class="col-sm-12"><strong>{{ estraiNomeGruppo(gruppoPermessi.idGruppo) }}</strong></span>
								</p>
							</div>

							<ng-template  ngFor let-permesso [ngForOf]="gruppoPermessi.permessi">
								<div class="col-sm-12 bloccodati" *ngIf="permesso.label && permesso.id.indexOf('_W_') != -1">
									<p>
										<span class="col-sm-12">{{permesso.label.replace('Modifica','').trim()}}
													- <em>lettura</em>
													- <em>scrittura</em>
										</span>
									</p>
								</div>
								<div class="col-sm-12 bloccodati" *ngIf="permesso.label && permesso.id.indexOf('_R_') != -1 && !elementInArray(permesso.id.replace('_R_','_W_'), gruppoPermessi.permessi)">
									<p>
									<span class="col-sm-12">{{permesso.label.replace('Leggi','').trim()}}
												- <em>lettura</em>
									</span>
									</p>
								</div>
							</ng-template>
						</li>
					</ul>
				</div>					
			</div>	
			
			<div class="gruppi_competenza" *ngIf="template.templateProfiloGruppiVisibilita && template.templateProfiloGruppiVisibilita.length > 0">
				<div class="titleblock template">
					<h4 class="titlelevelcompetenza">Gruppi di visibilit&agrave; per consultazione</h4>
				</div>	
					
				<div class="row">
					<ul class="gruppi">	
						<li>
							 <ng-template ngFor let-permesso [ngForOf]="template.templateProfiloGruppiVisibilita">
								   <div class="col-sm-12 bloccodati" *ngIf="permesso.label">
								 	   <p>
									   	<span class="col-sm-12">{{permesso.label}}</span>
									   </p>
 								   </div>
						     </ng-template>
						</li>
						
					</ul>
				</div>
					
			</div>	
			<div class="gruppi_competenza" *ngIf="template.templateProfiloGruppiSpeciali && template.templateProfiloGruppiSpeciali.length > 0">
				<div class="titleblock template">
					<h4 class="titlelevelcompetenza">Gruppi Speciali</h4>
				</div>	
				<div class="row">
					<ul class="gruppi">	
						<li>
							 <ng-template ngFor let-permesso [ngForOf]="template.templateProfiloGruppiSpeciali">
								   <div class="col-sm-12 bloccodati" *ngIf="permesso.label">
								 	   <p>
										<span class="col-sm-12">{{permesso.label}}</span>
									   </p>
 								   </div>
						     </ng-template>
						</li>
						
					</ul>
				</div>
					
			</div>
					
			<div class="gruppi_competenza" *ngIf="template.templateProfiloRuoli && template.templateProfiloRuoli.length > 0">
				<div class="titleblock template">
					<h4 class="titlelevelcompetenza">Ruoli</h4>
				</div>	
				<div class="row">
					<ul class="gruppi">	
						<li>
							 <ng-template ngFor let-permesso [ngForOf]="template.templateProfiloRuoli">
								   <div class="col-sm-12 bloccodati" *ngIf="permesso.nomeRuolo">
								 	   <p>
										<span class="col-sm-12">{{permesso.nomeRuolo}}</span>
									   </p>
 								   </div>
						     </ng-template>
						</li>
						
					</ul>
				</div>
					
			</div>			
			
			<div class="gruppi_competenza" *ngIf="template.templateProfiloPermessi && template.templateProfiloPermessi.length > 0">
				<div class="titleblock template">
					<h4 class="titlelevelcompetenza">Permessi</h4>
				</div>	
				<div class="row">
					<ul class="gruppi">	
						<li>
							<ng-template ngFor let-permesso [ngForOf]="template.templateProfiloPermessi">
									   <div class="col-sm-12 bloccodati" *ngIf="permesso.label && permesso.id.indexOf('_W_') != -1">
									 	   <p>
											<span class="col-sm-12">{{permesso.label.replace('Modifica','').trim()}}
													 - <em>lettura</em>
													 - <em>scrittura</em>
											</span>
										   </p>
	 								   </div>
	 								   <div class="col-sm-12 bloccodati" *ngIf="permesso.label && permesso.id.indexOf('_R_') != -1 && !elementInArray(permesso.id.replace('_R_','_W_'), template.templateProfiloPermessi)">
									 	   <p>
											<span class="col-sm-12">{{permesso.label.replace('Leggi','').trim()}}
													 - <em>lettura</em>
											</span>
										   </p>
	 								   </div>
						     </ng-template>
						</li>
					</ul>
				</div>
					
			</div>
	
			<div *ngIf="!disableModifica"  class="row">
				<div class="col-xs-6 visible-xs"></div>
				<div class="col-sm-3 col-xs-6 col-sm-offset-9">
					<button style="margin-top: 20px;" (click)="openModalUpdate(template)" type="button" class="btn btn-primary btn-block">Modifica dati</button>
				</div>
			</div>
</ng-template>
